import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { htmlRouting } from '../../comps/Nav'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'

export const ExploreProductsSection = ({ isMobile, isTab }: any) => {
  const { headerSize, headerLineHeight, textSize, textLineHeight } = useFontSize()
  const scrollTo = (key: string) => {
    if (window && document) {
      const element = document.getElementById(key)
      if (element) {
        setTimeout(() => {
          htmlRouting(key)
        }, 100)
      }
    }
  }
  return (
    <Box ph={isMobile || isTab ? undefined : 120} align={'center'}>
      <Text
        title={staticStrings.digitalPayments}
        fontFamily={'jiotype-black'}
        fontSize={headerSize}
        textAlign={'center'}
        lineHeight={headerLineHeight}
      />
      <Spacer size={32} />
      <Box ph={isMobile || isTab ? undefined : 180}>
        <Text
          color={'BLACK_21'}
          fontSize={textSize}
          fontFamily={'JioType-Light'}
          textAlign={'center'}
          opacity={0.9}
          lineHeight={textLineHeight}>
          JioPay is the
          <Text
            title={' Safest, Smartest '}
            fontFamily={'jiotype-bold'}
            color={'BLACK_21'}
            fontSize={textSize}
            textAlign={'center'}
            opacity={0.9}
            lineHeight={textLineHeight}
          />
          and
          <Text
            title={' Quickest '}
            fontFamily={'jiotype-bold'}
            color={'BLACK_21'}
            fontSize={textSize}
            textAlign={'center'}
            opacity={0.9}
            lineHeight={textLineHeight}
          />
          way to accept payments from your customers.
        </Text>
      </Box>
      <Spacer size={32} />
      <Box
        onPress={() => scrollTo('products')}
        underlayColor={'TRANSPARENT'}
        height={isMobile ? 48 : 56}
        bg={colors.HIGHLIGHT as ColorOptions}
        borderRadius={8}
        width={isMobile ? 180 : 212}
        align={'center'}
        justify={'center'}
        hoverColor={colors.HIGHLIGHT as ColorOptions}>
        <Text title={staticStrings.exploreProductsLabel} fontFamily={'JioType-Bold'} color={'WHITE'} fontSize={14} />
      </Box>
    </Box>
  )
}
